import { useCallback, useEffect, useState } from 'react';
import { debounce, DEBOUNCE_DEFAULT } from '../misc/debounce';

/**
 * Custom hook for more easily 'debouncing' our searches. This hook will
 * allow you create a new variable in your component that will serve
 * as your debounced search. You can use this with a useEffect hook so
 * that when our custom hook value updates, we can trigger the handler.
 *
 * Reference: https://usehooks.com/useDebounce/
 */
const useDebounce = (value, delay = DEBOUNCE_DEFAULT) => {
	const [debouncedValue, setDebouncedValue] = useState(value);
	// eslint-disable-next-line react-hooks/exhaustive-deps
	const debouncedSetDebouncedValue = useCallback(
		debounce(state => setDebouncedValue(state), delay),
		[]
	);

	useEffect(() => {
		debouncedSetDebouncedValue(value);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [value, delay]);

	return debouncedValue;
};

export default useDebounce;
